import { getApiUrl } from './graphql-utils';
import { getRefreshToken } from './storage';

const LOGOUT_TIMEOUT_MS = 2000;

/**
 * Ferme la session côté serveur avant de vider le stockage : sans ça, le refresh token resterait valide un an
 * après la déconnexion. Best-effort : une API injoignable ne doit pas empêcher de se déconnecter.
 */
export async function closeServerSession(): Promise<void> {
    const refreshToken = getRefreshToken();
    if (!refreshToken) return;

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), LOGOUT_TIMEOUT_MS);
    try {
        await fetch(`${getApiUrl()}/auth/logout`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ refreshToken }),
            signal: controller.signal,
        });
    } catch {
        // Le token reste valide côté serveur, mais plus personne ne le détient : la déconnexion locale suffit.
    } finally {
        clearTimeout(timeout);
    }
}
